<template>
<div class="container ">

    <div class="login_top">
        <div class="loginTopInner">
            <div class="loginLogoWrap">
            </div>
            <div class="welcome">
                欢迎来到积惠多购物
            </div>
            <div class="loginMore">
                登录获得更多优质的服务
            </div>
        </div>
    </div>

    <div class="loginBtnWrap">
      <button v-if="!ischeckbox" class="loginBtngrey">微信授权登录</button>
      <button v-else class="loginBtn" @click="getWechartLogin">微信授权登录</button>
    </div>

    <div class="nextTime">
        <span @click="nextTime">下次再说</span>
    </div>

	<div class='agreement'>
		<div>
      <span><van-checkbox checked-color="#F84F24" v-model="ischeckbox">我已阅读并同意</van-checkbox></span>
			<span class='user-agreement' @click="userAgreement">《用户服务协议》</span>
      <span class='user-agreement' @click="priPolicy">《隐私权政策》</span>
		</div>
	</div>

</div>


</template>
<script>

export default {
  name: '',
  components:{

  },
  data () {
    return {
      title: '',
      ischeckbox:false
    }
  },
  created() {
    window.getCode = this.getCode;
    this.$service.getStatisCommon("evn_open_page",{});
  },
  methods: {
    getWechartLogin(){
      if(window.android){
        window.android.setToken("wechartLogin")
      }
      this.$service.getStatisCommon("SA_PPA",{ed:{
        SAVer: "SAV 1.0",
        SAResult: true,
        PPAVer: "PPAV 1.0",
        PPAResult: true
      }});
    },
    nextTime(){
      this.$router.back()
      this.$service.getStatisCommon("evn_close_page",{});
    },
    userAgreement(){
      let pageUrl = process.env.VUE_APP_WEBVIEW_URL + "/o2o_help_center/ua.html?v=1.0"
      this.$router.push({path: '/outerPage',query:{pageUrl:pageUrl}})
      this.$service.getStatisCommon("SA",{});
    },
    priPolicy(){
      let pageUrl = process.env.VUE_APP_WEBVIEW_URL + "/o2o_help_center/private.html?v=1.0"
      this.$router.push({path: '/outerPage',query:{pageUrl:pageUrl}})
      this.$service.getStatisCommon("PPA",{});
    },
    getCode(code){
      if(code){
        this.$router.push({path:"/phoneLogin",query:{code:code}})
        this.$service.getStatisCommon("evn_close_page",{});
      }
    }
  }
}
</script>
<style scoped lang='less'>
/**index.wxss**/
.container{
    font-family: PingFangSC-Regular, sans-serif;
}


.container {
  display:flex; 
  display:-webkit-flex; 
  flex-direction:column;
  -webkit-flex-direction:column;
}

.agreement {
  font-size: 12px;
  text-align: center;
  margin-top: 1.6rem;
  color: #707070;
}
.agreement div{
  display: flex;
  justify-content: center;
  align-items: center;
}

.user-agreement {
  align-items:center;
  color: rgb(235,97,18); 
  font-size:12px; 
  font-family: PingFang-SC-ExtraLight, 'Source Han Sans CN Regular','Noto Sans CJK SC Regular';
}

.login_top{
    width:100%;
    position: relative;
    height:8.5333rem;
    background: url("../../assets/images/loginBg.png") no-repeat;
    background-size: 100% 100%;
}
.loginTopInner{
    position: absolute;
    top:0;
    left:0;
    right:0;
    text-align: center;
}
.loginLogoWrap{
    margin-top: 0.7467rem;
}
.loginLogo{
    width: 2.3467rem;
    height: 2.3467rem;
}
.loginMore{
    color: #4E3D2B;
    font-size: 14px;
}
.welcome{
    line-height:1.0667rem;
    font-size: 20px;
    font-family: PingFangSC-Medium, sans-serif;
    color: #49341F;
}

.loginBtnWrap{
    margin-top:1.6rem;
    text-align: center;
}
.loginBtngrey{
    width: 7.7333rem;
    height: 1.1733rem;
    line-height: 1.1733rem;
    background: #9CE6BF;
    color: #fff;
    font-size: 16px;
    border-radius: 1.1733rem;
    border:none;
}
.loginBtn{
    width: 7.7333rem;
    height: 1.1733rem;
    line-height: 1.1733rem;
    background: #08C160;
    color: #fff;
    font-size: 16px;
    border-radius: 1.1733rem;
    border:none;
}
.nextTime{
    font-size: 16px;
    color: #949494;
    margin-top:0.8rem;
    text-align: center;
}
</style>